import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './TweetCardContent.module.scss';
import { Grid } from '@material-ui/core';
import AvatarCell from '../Tables/Cells/AvatarCell';
import { checkTranslated } from 'app/utils/helpers';
import {
  BookmarkIcon,
  MarkedImportantIcon,
  ReplyIcon,
  TweetLikesIcon,
  TweetRetweetIcon,
  TweetShareIcon,
  TweetViewsIcon,
} from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import { nFormatter } from 'app/utils/numbersFormater';
import { openConfirmationPopup } from 'app/utils/confirmationPopup';
import { useModal } from 'app/context/Modal';
import DefaultVideo from '../../assets/images/defaultVideo.png';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { getTimeDifference } from 'app/utils/get-difference-times';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { path } from 'app/utils/path';
import { useHistory } from 'react-router-dom';
import { parseMentions } from 'app/utils/pasreMentions';
import AudioTextRow from '../AudioTextRow';

interface Props {
  parentTweetData?: any;
  conversationData?: any;
  conversationList?: any;
  openModalToAddInfluencer?: (url: string, name: string) => void;
  handleInfluencer?: (influencer?: object) => void;
  isQuote?: boolean;
  isInstagram?: boolean;
  hideImg?: boolean;
  borderBottom?: boolean;
  withAudioRow?: boolean;
  quoteUrl?: string;
}
const isEn = getFromLocalStorage('LNG') === 'en';

const RenderPersonalInfo = ({
  data,
  openModalToAddInfluencer,
  handleInfluencer,
}: {
  data: any;
  openModalToAddInfluencer?: (url: string, name: string) => void;
  handleInfluencer?: (influencer?: object) => void;
}) => (
  <Grid
    item
    className={styles.PersonalInfo}
    sm={12}
    style={{ cursor: 'pointer' }}
    onClick={() => {
      data?.influencer?.influencer_id === 0
        ? openModalToAddInfluencer?.(data?.influencer?.url, data?.username)
        : handleInfluencer?.(data?.influencer);
    }}
  >
    <AvatarCell
      img={data?.influencer?.image_url || data?.influencer?.image}
      rounded
    />
    <div className={styles.PersonalName}>
      <div>
        {data?.influencer?.name?.original?.length
          ? data?.influencer?.name?.original
          : data?.username}
        {!!data?.influencer?.is_profile_verified && <MarkedImportantIcon />}
      </div>
      <p dir="auto">
        <span>@{data?.username}</span>.
        <span>{getTimeDifference(data?.published_at)}</span>
      </p>
    </div>
  </Grid>
);

const RenderPersonalRepliesInfo = ({
  data,
  openModalToAddInfluencer,
  handleInfluencer,
}: {
  data: any;
  openModalToAddInfluencer?: (url: string, name: string) => void;
  handleInfluencer?: (influencer?: object) => void;
}) => (
  <div
    className={styles.PersonalReplies}
    style={{ cursor: 'pointer', width: 'max-content' }}
    onClick={() =>
      data?.influencer?.influencer_id === 0
        ? openModalToAddInfluencer?.(data?.influencer?.url, data?.username)
        : handleInfluencer?.(data?.influencer)
    }
  >
    <div className={styles.PersonalName}>
      <div>
        {' '}
        {data?.influencer?.name?.original?.length
          ? data?.influencer?.name?.original
          : data?.username}
      </div>
      {!!data?.influencer?.is_profile_verified && <MarkedImportantIcon />}
      <p>
        <span>
          @{data?.username} - {getTimeDifference(data.published_at)}
        </span>
      </p>
    </div>
    {!!data?.reply_to?.length && (
      <div className={styles.ReplyWrapper} dir="auto">
        <p>{_t('basic:replying_to')}</p>
        <div
          style={{ cursor: 'pointer' }}
          onClick={() =>
            data?.influencer?.influencer_id === 0
              ? openModalToAddInfluencer?.(data?.influencer?.url, data?.username)
              : handleInfluencer?.(data?.influencer)
          }
        >
          @{data?.reply_to}
        </div>
      </div>
    )}
  </div>
);
const RenderContent = ({
  data,
  handleInfluencer,
  openModalToAddInfluencer,
  isInstagram,
  hideImg,
  borderBottom,
  withAudioRow,
  quoteUrl,
}: {
  data: any;
  openModalToAddInfluencer?: (url: string, name: string) => void;
  handleInfluencer?: (influencer?: object) => void;
  isInstagram?: boolean;
  hideImg?: boolean;
  borderBottom?: boolean;
  withAudioRow?: boolean;
  quoteUrl?: string;
}) => {
  const history = useHistory();
  return (
    <>
      <Grid
        className={`${styles.text} ${borderBottom ? styles.borderBottom : ''}`}
        style={{ marginBottom: isInstagram && !hideImg ? 0 : undefined }}
      >
        <span
          onClick={() =>
            isInstagram
              ? undefined
              : history.push(
                  `${!!quoteUrl?.length ? quoteUrl : path.posts.TWITTER_POST_DETAILS_URI}/${data?.id}`,
                )
          }
          className={isInstagram ? '' : 'cursor-pointer'}
        >
          {isInstagram
            ? parseMentions(
                checkTranslated(
                  data?.text?.original ||
                    data?.caption?.original ||
                    data?.content?.original,
                  data?.text?.arabic ||
                    data?.caption?.arabic ||
                    data?.content?.arabic,
                ),
                (url, username) => openModalToAddInfluencer?.(url, username),
                (data) => handleInfluencer?.(data),
                data?.post_mentions ||data?.mentions,
              )
            : checkTranslated(data?.content?.original, data?.content?.arabic)}
        </span>
        {withAudioRow ? (
          <div style={{ marginBottom: '-20px', marginTop: '20px' }}>
            <AudioTextRow data={data} />
          </div>
        ) : (
          <></>
        )}
        {(!isInstagram || hideImg) && (
          <div
            style={{
              height: isInstagram ? '20px' : '',
              cursor: isInstagram ? '' : 'pointer',
            }}
            onClick={() =>
              isInstagram
                ? ''
                : history.push(
                    `${path.posts.TWITTER_POST_DETAILS_URI}/${data?.id}`,
                  )
            }
          ></div>
        )}
      </Grid>
      {!hideImg ? <RenderMediaRow data={data} /> : <></>}
    </>
  );
};

const ActionsRow = ({ data }: { data: any }) => {
  const ActionRowData = [
    {
      icon: <ReplyIcon />,
      count: data?.replies_count,
      id: 'replies',
    },
    {
      icon: <TweetRetweetIcon />,
      count: data?.retweets_count,
      id: 'retweet',
    },
    {
      icon: <TweetLikesIcon />,
      count: data?.likes_count,
      id: 'likes',
    },
    {
      icon: <TweetViewsIcon />,
      count: data?.views,
      id: 'views',
    },
  ];
  return (
    <div className={styles.RowActionsWrapper}>
      <div className={styles.RowActions}>
        {ActionRowData?.map((item) => (
          <div key={item?.id}>
            <p>{item?.icon}</p>
            <p>{nFormatter(item.count)}</p>
          </div>
        ))}
      </div>
      <div className={styles.shareBookmark}>
        <BookmarkIcon />
        <TweetShareIcon />
      </div>
    </div>
  );
};
const RenderQuoteTweet = ({
  data,
  handleInfluencer,
  openModalToAddInfluencer,
  isInstagram,
  hideImg,
  borderBottom,
  withAudioRow,
  quoteUrl,
}: {
  data: any;
  openModalToAddInfluencer?: (url: string, name: string) => void;
  handleInfluencer?: (influencer?: object) => void;
  isInstagram?: boolean;
  hideImg?: boolean;
  borderBottom?: boolean;
  withAudioRow?: boolean;
  quoteUrl?: string;
}) => (
  <Grid
    container
    className={`${styles.TweetCardContent} ${borderBottom && styles.hideBorder}`}
  >
    <RenderPersonalInfo
      data={data}
      {...{ handleInfluencer, openModalToAddInfluencer }}
    />
    <RenderContent
      {...{
        data,
        isInstagram,
        handleInfluencer,
        openModalToAddInfluencer,
        hideImg,
        borderBottom,
        withAudioRow,
        quoteUrl,
      }}
    />
  </Grid>
);

const RenderMediaRow = ({ data }: { data: any }) => {
  const modal = useModal();
  const handelOpenOneImage = () => {
    modal.show({
      imageUrl: data?.attachments?.[0]?.url,
    });
  };
  const handelOpenImage = (index = 0) => {
    modal.show({
      imageUrls: data?.attachments,
      imageIndex: index,
    });
  };

  return data?.attachments?.length ? (
    <Grid
      className={`${styles.oneImgContainer} 
      ${data?.attachments?.length === 3 ? styles.oneImgContainer_three_items : ''}
      ${data?.attachments?.length === 1 ? styles.oneImgContainer_one_item : ''}
      `}
    >
      {data?.attachments?.map(
        (
          attach: { url: string; thumbnail: string; type: string },
          index: number,
        ) =>
          attach?.type !== 'VIDEO' ? (
            <img
              src={attach?.url}
              alt="image"
              key={attach?.url}
              onClick={() => {
                data?.attachments?.length === 1
                  ? handelOpenOneImage()
                  : handelOpenImage(index);
              }}
              className=""
            />
          ) : (
            <a
              target="_blank"
              rel="noreferrer"
              onClick={() => handelOpenImage(index)}
              key={attach?.url}
            >
              <img
                src={attach.thumbnail ? attach.thumbnail : DefaultVideo}
                alt=" image alt"
              />
              {attach?.type === 'VIDEO' && attach?.thumbnail?.length !== 0 && (
                <a
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => handelOpenImage(index)}
                  className={styles.VideoBtn}
                >
                  <PlayArrowIcon />
                </a>
              )}
            </a>
          ),
      )}
    </Grid>
  ) : (
    <></>
  );
};
const TweetCardContent: FunctionComponent<Props> = ({
  parentTweetData,
  conversationData,
  conversationList,
  openModalToAddInfluencer,
  handleInfluencer,
  isQuote,
  isInstagram,
  hideImg,
  borderBottom,
  withAudioRow,
  quoteUrl,
}) => {
  if (isQuote) {
    return (
      <RenderQuoteTweet
        {...{
          data: parentTweetData,
          openModalToAddInfluencer,
          handleInfluencer,
          isInstagram,
          hideImg,
          borderBottom,
          withAudioRow,
          quoteUrl,
        }}
      />
    );
  }

  if (conversationList?.length) {
    return (
      <Grid
        container
        className={styles.RepliesContent}
        data-type={conversationData?.url}
      >
        <div
          className={styles.imageWrapper}
          style={{ cursor: 'pointer' }}
          onClick={() =>
            conversationData?.influencer?.influencer_id === 0
              ? openModalToAddInfluencer?.(
                  conversationData?.url,
                  conversationData?.username,
                )
              : handleInfluencer?.(conversationData?.influencer)
          }
        >
          <AvatarCell img={conversationData?.influencer?.image_url} rounded />
          <div className={styles.magicBorder}></div>
        </div>
        <div className={styles.RepliesContentInfo}>
          <RenderPersonalRepliesInfo
            {...{
              data: conversationData,
              openModalToAddInfluencer,
              handleInfluencer,
            }}
          />

          <RenderContent data={conversationData} />
          {conversationData?.parent_tweet !== null &&
          Number(conversationData?.parent_tweet?.id) !== 0 &&
          conversationData?.has_parent ? (
            <RenderQuoteTweet
              data={conversationData?.parent_tweet}
              {...{ handleInfluencer, openModalToAddInfluencer }}
            />
          ) : (
            <></>
          )}
          <ActionsRow data={conversationData} />
        </div>
      </Grid>
    );
  }

  return <></>;
};

export default TweetCardContent;
